import "./progressBar.scss";
import classnames from "classnames";
function ProgressBar(props) {
  return (
    <>
      {props.svg ? (
        // Progress Bar SVG
        <div className="progressBar-svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 693 21.39">
            <defs></defs>
            <g id="Layer_2" data-name="Layer 2">
              <g id="ProgressBar">
                <path
                  id="ThinLine"
                  className="cls-1"
                  d="M2.5,8.09c16,.18,57.26.88,94.41,2.16,46.44,1.6,92.38,7.53,203.63,6S431.19,6.83,534.28,3.63,692.49,5.09,690.45,5.09"
                />
                <path
                  id="ThickLine"
                  style={{
                    strokeDashoffset: ` ${693 - 693 * (props.progress / 100)} `,
                  }}
                  className="cls-2"
                  d="M2.5,8.09c16,.18,57.26.88,94.41,2.16,46.44,1.6,92.38,7.53,203.63,6S431.19,6.83,534.28,3.63,692.49,5.09,690.45,5.09"
                />
                {/* <circle 
                  id="Dot" 
                  className="cls-3" 
                  r="6.14"> */}
                {/* <animateMotion dur="5s" repeatCount="1"  
                      keyPoints="0; {props.progress/100}; 0.5" 
                      keyTimes="0; 0.5; 1" 
                      calcMode="linear">
                    <mpath xlinkHref="#ThinLine"/>
                  </animateMotion>   */}

                {/* </circle>   */}
              </g>
            </g>
          </svg>
        </div>
      ) : (
        // Progress Bar Line
        <div className="progressBar">
          <div
            className={classnames(
              "progressBar--state progress",
              `progress-${props.progress}`
            )}
            style={{ width: `${props.progress}%` }}
          ></div>
        </div>
      )}
    </>
  );
}

export default ProgressBar;
